import { ProjectMetadataRow } from "./project-metadata-row";

interface ProjectProfileCardProps {
  name: string;
  role: string;
  avatarUrl?: string;
  propertyId: string;
  constructionYear: number;
  projectType: string;
  registrationDate: string;
}

export function ProjectProfileCard({
  name,
  role,
  avatarUrl,
  propertyId,
  constructionYear,
  projectType,
  registrationDate,
}: ProjectProfileCardProps) {
  return (
    <div className="bg-[#0C1427] rounded-[10px] overflow-clip h-[380px] w-full flex flex-col gap-[28px] items-center p-[20px]">
      {/* Header with Avatar */}
      <div className="flex flex-col gap-[10px] items-center w-full">
        <div className="flex flex-col gap-[6px] items-center justify-center w-[385px]">
          {/* Purple Header with Overlapping Avatar */}
          <div className="relative grid grid-cols-[max-content] grid-rows-[max-content] place-items-start leading-[0]">
            {/* Purple background */}
            <div className="bg-[#7846FF] h-[94px] w-[386px]" />

            {/* Avatar overlapping */}
            <div className="absolute left-[131.5px] top-[24px] w-[123px] h-[123px]">
              {avatarUrl ? (
                <img
                  src={avatarUrl}
                  alt={name}
                  className="w-full h-full rounded-full object-cover"
                />
              ) : (
                <div className="w-full h-full rounded-full bg-purple-600 flex items-center justify-center text-white text-3xl font-semibold">
                  {name.charAt(0)}
                </div>
              )}
            </div>
          </div>

          {/* Name and Role */}
          <div className="flex flex-col items-center justify-center leading-normal text-center whitespace-pre">
            <p className="font-['Plus_Jakarta_Sans'] font-semibold text-[#f6f6f6] text-[20px]">
              {name}
            </p>
            <p className="font-['Plus_Jakarta_Sans'] font-normal text-[#b0b0b0] text-[14px]">
              {role}
            </p>
          </div>
        </div>
      </div>

      {/* Metadata Rows */}
      <div className="flex flex-col gap-[20px] items-start w-full">
        <ProjectMetadataRow
          label="Propriedade ID:"
          value={propertyId}
          size="sm"
        />
        <ProjectMetadataRow
          label="Ano de Construção:"
          value={constructionYear}
          size="sm"
        />
        <ProjectMetadataRow
          label="Tipo de Projeto:"
          value={projectType}
          size="sm"
        />
        <ProjectMetadataRow
          label="Data de Cadastro:"
          value={registrationDate}
          size="sm"
        />
      </div>
    </div>
  );
}
